module.exports = __webpack_public_path__ + "img/404.eba37d75.png";